/* eslint-disable max-len */
import React, {
    useContext,
    useEffect,
} from 'react';

import {
    Box,
    Flex,
    VStack,
    Image,
    Spacer,
    Text,
    OrderedList,
    ListItem,
} from '@chakra-ui/react';

import { ToastBoxContext } from '../../contexts/ToastBoxContext';

// images path
import chainsOfEffecstsPath from '../../resources/chainsOfEffects.png';
import susADPath from '../../resources/SusAD.png';

import PageTitle from '../../components/PageTitle';

function Analysis() {
    const {
        toast,
        onCloseToast,
    } = useContext(ToastBoxContext);

    // close toast message if open
    useEffect(
        () => {
            if (toast) {
                onCloseToast();
            }
        },
        [onCloseToast, toast],
    );

    return (
        <VStack
            align="stretch"
            spacing={4}
            role="main"
        >
            <PageTitle
                title="Analysis"
            />

            <Flex
                borderWidth={1}
                width="100%"
                padding={8}
                marginBottom={1}
            >
                <Box width="50%">
                    <Text
                        fontSize={24}
                        fontWeight="bold"
                        background="#045981"
                        color="white"
                        padding={2}
                        marginBottom={2}
                    >
                        SUSAD
                    </Text>
                    <Text fontSize={18} fontWeight="bold">
                        Fill the SusaD:
                    </Text>

                    <OrderedList
                        paddingX={4}
                        paddingY={2}
                        width="100%"
                    >
                        <ListItem p={2}>
                            Paste the effects from the high impact and likelihood corner of the matrix onto the
                            SusAD according to dimension and order of effect.
                        </ListItem>
                        <ListItem p={2}>
                            Add the ones that are less likely and less impactful to the degree that is deemed
                            necessary or beneficial by the group. (Not all post-its have to be transferred.)
                        </ListItem>
                    </OrderedList>
                </Box>
                <Spacer />
                <Image
                    src={susADPath}
                    alt="logo"
                    role="img"
                    width="40%"
                />
            </Flex>
            {/* NEXTG */}
            <Flex
                borderWidth={1}
                width="100%"
                padding={8}
                marginBottom={1}
            >
                <Image
                    src={chainsOfEffecstsPath}
                    alt="logo"
                    role="img"
                    width="40%"
                />
                <Spacer />

                <Box width="50%">
                    <Text
                        fontSize={24}
                        fontWeight="bold"
                        background="#045981"
                        color="white"
                        padding={2}
                        marginBottom={2}
                    >
                        Chains of Effects
                    </Text>
                    <Text fontSize={18} fontWeight="bold">
                        Identify: key chains of effect
                    </Text>
                    <Text fontSize={18} marginTop={12}>
                        Draw relations between the effects that may happen when many people use this product or
                        service for several years:
                    </Text>
                    <OrderedList
                        paddingX={4}
                        paddingY={2}
                        width="100%"
                    >
                        <ListItem p={2}>
                            Think about which second order effects stem from which first order effects, and
                        </ListItem>

                        <ListItem p={2}>
                            which third order effects can be a consequence of some second order effects
                        </ListItem>
                        <ListItem p={2}>
                            Effects can also have a related effect of the same order, and/or of a different
                            dimension
                        </ListItem>
                    </OrderedList>

                    <Text fontSize={18} marginTop={12}>
                        Example: If people feel closer to their neighbors, they can choose to shop at local
                        stores or choose local products, which can encourage local businesses and ultimately
                        distribute wealth better
                    </Text>
                </Box>
            </Flex>

        </VStack>
    );
}

export default Analysis;
